import { environment } from '@environments/environment';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';

/**
 * Build full URL from relative path.
 * Handles images, videos, exports, downloads — any file path.
 * Returns null if path is empty; callers handle their own fallback.
 */
export function buildUrl(path: string | null | undefined): string | null {
    if (!path) return null;
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
    const normalized = path.startsWith('/') ? path : `/${path}`;
    return `${environment.STORAGE_BASE_URL}${normalized}`;
}

/**
 * Build safe URL for iframe/video embedding
 * Returns SafeUrl for Angular template binding
 *
 * @param sanitizer - Angular DomSanitizer
 * @param url - URL (blob:, full URL, or relative path)
 * @returns SafeUrl or null
 */
export function buildSafeUrl(
    sanitizer: DomSanitizer,
    url: string | null | undefined
): SafeUrl | null {
    if (!url) return null;

    // blob: URLs (local video uploads)
    if (url.startsWith('blob:')) {
        return sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    // Already full URL
    if (url.startsWith('http://') || url.startsWith('https://')) {
        return sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    // Relative path - build full URL
    const normalized = url.startsWith('/') ? url : `/${url}`;
    return sanitizer.bypassSecurityTrustResourceUrl(
        `${environment.STORAGE_BASE_URL}${normalized}`
    );
}